import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Button,
  Card,
  Checkbox,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Blogtype } from "../../types/General";
import { Loader, showError, showToast } from "../../constants";
import { isValidInput } from "../../utils/validations";
import { Pagination, WarnModal } from "../../components";
import {
  useLazyChangeBlogStatusQuery,
  useLazyDeleteBlogByIdQuery,
  useLazyGetAllBlogsQuery,
} from "../../services/blogs";
import moment from "moment";
import useAuth from "../../hooks/useAuth";
import { Permissions } from "../../types/User";

const ManageBlogs = () => {
  const userData = useAuth();
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [blogsData, setBlogsData] = useState<Blogtype[]>([]);
  const [blogStatus, getBlogStatusData] = useLazyChangeBlogStatusQuery();

  const [getBlogs, { isLoading }] = useLazyGetAllBlogsQuery();
  const [deleteBlogById, deleteBlogByIdData] = useLazyDeleteBlogByIdQuery();
  const [hidePermission, setHidePermission] = useState<
    Permissions | null | undefined
  >(null);

  const checkPermission = () => {
    const permission = userData?.permissions;
    if (permission?.length) {
      let idx = -1;
      idx = permission?.findIndex(
        (ele: Permissions) => ele?.label === "Manage Blogs"
      );
      if (idx > -1) {
        setHidePermission(permission[idx]);
      } else {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    if (userData && userData?.permissions?.length) {
      checkPermission();
    }
  }, [userData]);

  let totalPages = Math.ceil(totalCount / 10);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getBlogsData = async () => {
    try {
      const response = await getBlogs({
        page: page,
        limit: 10,
        query: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setBlogsData(response?.data?.blogs || []);
        setTotalCount(response?.data?.blogsCount);
      } else {
        setBlogsData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  const updateStatus = async (id: string) => {
    try {
      const response = await blogStatus({ blog_id: id }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Status updated successfully");
        const res = await getBlogs({
          page: page,
          limit: 10,
          query: debouncedSearchTerm.trim(),
        }).unwrap();
        if (res?.statusCode === 200) {
          setBlogsData(res?.data?.blogs || []);
          setTotalCount(res?.data?.blogsCount);
        } else {
          setBlogsData([]);
        }
      } else {
        showError("Please try again");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await deleteBlogById({
        blog_id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast(response?.message || "");
        const res = await getBlogs({
          page: page,
          limit: 10,
          query: debouncedSearchTerm.trim(),
        }).unwrap();
        if (res?.statusCode === 200) {
          setBlogsData(res?.data?.blogs || []);
          setTotalCount(res?.data?.blogsCount);
        } else {
          setBlogsData([]);
        }
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getBlogsData();
  }, [debouncedSearchTerm, page]);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  return (
    <MainContainer>
      <Loader
        isLoad={
          isLoading ||
          deleteBlogByIdData?.isLoading ||
          getBlogStatusData?.isLoading
        }
      />
      <div className="main_loyout">
        <div className="dashboard">
          <h1>Manage Blogs</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            {hidePermission?.isEdit || userData?.role === "ADMIN" ? (
              <Button
                className="btn btn_primary"
                onClick={() => {
                  navigate("/manage-blogs/add-blog");
                }}
              >
                Add Blog
              </Button>
            ) : null}
          </Box>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              {blogsData?.length ? (
                blogsData?.map((item, i) => {
                  return (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center">
                          {" "}
                          {(page - 1) * 10 + i + 1}
                        </TableCell>
                        <TableCell>
                          {moment(item?.createdAt).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>{item?.title}</TableCell>

                        <TableCell>
                          <Switch
                            {...label}
                            size="small"
                            checked={!item?.isBlocked}
                            onChange={() => updateStatus(item?._id)}
                          />
                        </TableCell>
                        <TableCell>
                          <Box className="table_actions">
                            <IconButton
                              onClick={() =>
                                navigate(`/manage-blogs/details/${item?._id}`)
                              }
                            >
                              <VisibilityIcon />
                            </IconButton>
                            {hidePermission?.isEdit ||
                            userData?.role === "ADMIN" ? (
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-blogs/edit/${item?._id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                            ) : null}

                            {hidePermission?.isDelete ||
                            userData?.role === "ADMIN" ? (
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(item?._id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            ) : null}
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  );
                })
              ) : (
                <TableBody>
                  <TableCell
                    align="center"
                    colSpan={10}
                    sx={{ color: "white" }}
                  >
                    No Blogs Found
                  </TableCell>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Card>
        <Pagination
          module={blogsData}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      </div>
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDelete(selectedId)}
        name="blog"
      />
    </MainContainer>
  );
};

export default ManageBlogs;
